/** @odoo-module **/

import {Component, mount, xml, useState, useEffect, useRef, onWillStart} from "@odoo/owl";

export class WPCPortalAccountStatus extends Component {
    static template = 'wpc_portal.account_status'
    static components = {

    }
    static props = {
        currentPage: { type: String, optional: true },
    }
    static defaultProps = {
        currentPage: '',
    }
    setup() {
        var self = this;
    }

    doLogout() {
        var self = this;
//        self.state.lastErrorMessage = '';
        $.ajax({url: '/auth/logout', dataType: 'json', type:'POST', data: {
            // csrf_token: odoo.csrf_token,
        }})
        .then((result)=>{
            self.env.refresh_login_status();
        }).fail((err)=>{
            debugger;
        })
    }
}
